import { useState } from "react";
import { useLocation } from "react-router-dom";
import { ExternalLink, X } from "lucide-react";

const HIDE_ON = ["/live", "/station"];
const KEY = "sfap-parish-badge-hidden";

export function ParishSiteBadge() {
  const { pathname } = useLocation();
  const [hidden, setHidden] = useState(() => sessionStorage.getItem(KEY) === "1");
  if (hidden || HIDE_ON.some((p) => pathname.startsWith(p))) return null;
  const hide = () => { sessionStorage.setItem(KEY, "1"); setHidden(true); };
  return (
    <div className="no-print fixed bottom-4 right-4 z-40 group parish-badge" data-testid="parish-site-badge">
      <a href="https://mabuhayparish.org" target="_blank" rel="noopener noreferrer" aria-label="Visit the Saint Francis of Assisi Parish website, mabuhayparish.org"
        className="flex flex-row-reverse items-center rounded-full bg-[#FDFBF7]/95 backdrop-blur-md border border-[#D4AF37]/60 shadow-[0_10px_28px_-12px_rgba(60,40,20,0.55)] pl-1 transition-[box-shadow,transform] duration-300 hover:shadow-[0_14px_34px_-12px_rgba(60,40,20,0.7)] hover:-translate-y-0.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#C85A32]"
        data-testid="parish-site-link">
        <span className="block h-12 w-12 rounded-full bg-[#FDFBF7] ring-1 ring-[#D4AF37]/50 p-1 shrink-0">
          <img src="/parish-seal.png" alt="Saint Francis of Assisi Parish seal" className="h-full w-full object-contain" />
        </span>
        <span className="overflow-hidden whitespace-nowrap max-w-0 opacity-0 group-hover:max-w-[240px] group-hover:opacity-100 group-focus-within:max-w-[240px] group-focus-within:opacity-100 transition-[max-width,opacity] duration-500 ease-out">
          <span className="flex flex-col pl-3 pr-3 leading-tight text-right">
            <span className="text-[10px] uppercase tracking-[0.22em] text-[#8A6D3B]">Visit our Parish</span>
            <span className="font-serif font-bold text-[#2D3B2D] text-sm flex items-center gap-1">mabuhayparish.org <ExternalLink className="h-3.5 w-3.5" /></span>
          </span>
        </span>
      </a>
      <button onClick={hide} aria-label="Hide parish website shortcut" title="Hide for now"
        className="absolute -top-1.5 -left-1.5 h-5 w-5 rounded-full bg-[#2D3B2D] text-[#FDFBF7] grid place-items-center opacity-0 group-hover:opacity-100 focus:opacity-100 transition-opacity duration-300"
        data-testid="parish-site-badge-hide"><X className="h-3 w-3" /></button>
    </div>
  );
}
